<template>
  <div>
    <PlantillaContenido>
      <div slot="titulo">
        <i class="fas fa-file icon"></i>
        Eliminados
      </div>
      <div slot="breadCrumb">
        <nav class="breadcrumb" aria-label="breadcrumbs">
          <ul>
            <li>
              <router-link :to="{ name: 'administrativeHome' }">
                <span>
                  <i class="fas fa-home icon"></i>
                  inicio
                </span>
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'cellarsAdministrative' }">
                <span>
                  <i class="fas fa-boxes icon"></i>
                  Bodegas
                </span>
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'documentsAdministrative' }">
                <span>
                  <i class="fas fa-file icon"></i>
                  Documentos
                </span>
              </router-link>
            </li>
            <li class="is-active">
              <router-link :to="{ name: 'trashAdministrative' }">
                <span>
                  <i class="fas fa-file icon"></i>
                  Eliminados
                </span>
              </router-link>
            </li>
          </ul>
        </nav>
      </div>
      <div slot="contenido">
        <div class="box">
          <b-table
            type="is-primary"
            :data.sync="listDocument.data"
            :loading="loading"
            :paginated="isPaginated"            
            :current-page.sync="currentPage"
            :pagination-simple="isPaginationSimple"
            :default-sort-direction="defaultSortDirection"
            :sort-icon="sortIcon"
            :sort-icon-size="sortIconSize"
            :is-fullwidth="true"
            default-sort="stablishment.name"
            aria-next-label="Next page"
            aria-page-label="Page"
            aria-current-label="Current page"
            narrowed
            detailed
             backend-pagination
            :total="listDocument.total"
            :per-page="listDocument.per_page"
            @page-change="chargeDocumentList"
          >
            <template slot-scope="props">
              <b-table-column field="favorite">
                <b-icon
                  v-if="props.row.favorite == '1'"
                  type="is-warning"
                  icon="star"
                  size="is-small"
                >
                </b-icon>
              </b-table-column>
              <b-table-column field="number" label="N° Documento" searchable>{{
                props.row.number
              }}</b-table-column>
              <b-table-column field="date_document" label="Fecha" searchable>
                <span class="tag is-success">
                  {{ props.row.date_document }}
                </span>
              </b-table-column>
              <b-table-column
                field="document_type.name"
                label="Tipo de Documento"
                searchable
                >{{ props.row.document_type.name }}</b-table-column
              >
              <b-table-column field="cellar.name" label="Bodega" searchable>{{
                props.row.cellar.name
              }}</b-table-column>

              <b-table-column label="Action" width="200px">
                <div class="buttons">
                  <b-button
                    type="is-primary is-small"
                    icon-left="search"
                    @click="openViewPdf(props.row.id)"
                  ></b-button>
                  <b-button
                    type="is-success is-small"
                    icon-left="plus"
                    @click="reviveDocument(props.row.id)"
                  ></b-button>
                  <a :href="props.row.file" target="_blank">
                    <b-button
                      type="is-primary is-small"
                      icon-left="download"
                    ></b-button>
                  </a>
                </div>
              </b-table-column>
            </template>
             <template slot="detail" slot-scope="props">
                <article class="media">                    
                    <div class="media-content">
                        <div class="content">
                            <p>
                                <b>Descripción:</b> {{props.row.description}}
                            </p>
                        </div>
                    </div>
                </article>
            </template>
          </b-table>
        </div>
      </div>
    </PlantillaContenido>
  </div>
</template>
<script>
import PlantillaContenido from "../../../template/PlantillaContenido";
import ViewPdf from "../../../components/administrative/document/ViewPdf";
// import { getDocumentTrash, restoreDocument } from "../../../services/document";
import { DocumentService } from '../../../services/models/document';

export default {
  components: {
    PlantillaContenido,
  },
  data() {
    return {
      user_type_id: null,
      listDocument: [],
      loading: false,

      isFullPage: true,
      isComponentModalActive: false,
      isPaginated: true,
      isPaginationSimple: false,
      paginationPosition: "bottom",
      defaultSortDirection: "asc",
      sortIcon: "arrow-up",
      sortIconSize: "is-small",
      currentPage: 1,
      perPage: 5,
    };
  },
  mounted: function () {
    this.chargeDocumentList();
  },
  methods: {
    openViewPdf(id) {
      this.$buefy.modal.open({
        parent: this,
        component: ViewPdf,
        fullScreen: true,
        props: {
          id: id,
          chargeDocumentList: this.chargeDocumentList,
        },
        hasModalCard: true,
        trapFocus: true,
      });
    },
    async chargeDocumentList() {
      this.loading = true;
      const {data : documents} = await DocumentService.getTrashByCellarId(this.$route.params.id);
      this.listDocument = documents;
      // this.listDocument = await getDocumentTrash(
      //   this.$http,
      //   this.$route.params.id
      // );
      this.loading = false;
    },
    async reviveDocument(id) {
      this.$buefy.dialog.confirm({
        title: "¿Desea restaurar este documento?",
        message: "Una vez restaurado, volvera a la bandeja principal",
        confirmText: "Restaurar",
        type: "is-warning",
        hasIcon: true,
        onConfirm: async () => {
          this.loading = true;
          await DocumentService.restore(id);
          // await restoreDocument(this.$http, id);
          this.chargeDocumentList();
          this.$buefy.notification.open({
            message: "Documento Restaurado!",
            type: "is-success",
          });
          this.loading = false;
        },
      });
    },
  },
};
</script>

